import React, { useEffect, useState } from 'react';
import { useAuthentication } from '../../../../hooks/useAuthentication';
import SpecialBillingList from './SpecialBillingList';
import * as api from '../../../../services/apis';
import { showToast } from '../../../../helpers/showToast';
import { useTranslation } from 'react-i18next';
import { removeDuplicateAgreements } from '../../../../helpers/common';

const SpecialBillingListContainer = () => {
  const { t } = useTranslation();

  const [specialBillingList, setSpecialBillingList] = useState([]);
  const [originalSpecialBillingList, setOriginalSpecialBillingList] = useState(
    [],
  );
  const [tableLoading, setTableLoading] = useState(true);

  const { logout, userInfo } = useAuthentication();

  const getSpecialBillingList = (taxNumber) => {
    api
      .getSpecialBillingList(taxNumber)
      .then((resp) => {
        const responseList = removeDuplicateAgreements(resp?.data || []);
        setOriginalSpecialBillingList(responseList);
        setSpecialBillingList(responseList);
        setTableLoading(false);
      })
      .catch((err) => {
        if (err?.status === 401) {
          // eslint-disable-next-line no-undef
          logout({ redirect: location.pathname });
        }
        setTableLoading(false);
      });
  };

  const confirmDeleteAgreement = (deleteAgreement) => {
    api.deleteSpecialBillingAgreement(deleteAgreement.agreementId).then(() => {
      showToast({
        data: {
          variant: 'success',
          text: t('special_billing.delete_success_message'),
        },
      });
      getSpecialBillingList(userInfo.tax_number);
    });
  };

  const confirmTerminateAgreements = (terminateAgreements, reason) => {
    setTableLoading(true);
    return api
      .terminateSpecialBillingAgreements(terminateAgreements, reason)
      .then(() => {
        setTableLoading(false);
      })
      .catch(() => {
        setTableLoading(false);
      });
  };

  useEffect(() => {
    if (userInfo) {
      getSpecialBillingList(userInfo.tax_number);
    }
  }, [userInfo]);

  return (
    <SpecialBillingList
      renderedAgreements={specialBillingList}
      originalAgreements={originalSpecialBillingList}
      setSpecialBillingList={setSpecialBillingList}
      tableLoading={tableLoading}
      confirmDeleteAgreement={confirmDeleteAgreement}
      confirmTerminateAgreements={confirmTerminateAgreements}
    />
  );
};

export default SpecialBillingListContainer;
